<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="报告类型：" prop="report_type">
                <el-input :value="transEnu(model.report_type, 'report_type')" disabled></el-input>
            </el-form-item>
            <el-form-item label="月份：" prop="month">
                <el-date-picker v-model="model.month" type="month" value-format="yyyyMM" placeholder="选择月份" style="width: 150px"></el-date-picker>
            </el-form-item>
            <el-form-item label="数据ID：" prop="data_id">
                <el-input v-model="model.data_id" style="width: 150px"></el-input>
                <el-button type="primary" style="margin-left: 10px" @click="getReportInfo">获取数据</el-button>
            </el-form-item>
            <el-form-item label="开始地点：" prop="begin_address">
                <el-input v-model="model.begin_address"></el-input>
            </el-form-item>
            <el-form-item label="结束地点：" prop="end_address" v-if="model.report_type==1">
                <el-input v-model="model.end_address"></el-input>
            </el-form-item>
            <el-form-item label="时间显示：" prop="show_time">
                <el-input v-model="model.show_time"></el-input>
            </el-form-item>
            <el-form-item label="显示用时：" prop="show_duration">
                <el-input v-model="model.show_duration"></el-input>
            </el-form-item>
            <el-form-item label="消耗电量：" prop="charge_in" v-if="model.report_type==1">
                <el-input v-model="model.charge_in"></el-input>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in" v-if="model.report_type==2">
                <el-input v-model="model.charge_in"></el-input>
            </el-form-item>
            <el-form-item label="费用：" prop="fee" v-if="model.report_type==1">
                <el-input v-model="model.fee"></el-input>
            </el-form-item>
            <el-form-item label="行驶里程：" prop="mileage" v-if="model.report_type==1">
                <el-input v-model="model.mileage"></el-input>
            </el-form-item>
            <el-form-item label="开始剩余里程：" prop="begin_mileage">
                <el-input v-model="model.begin_mileage"></el-input>
            </el-form-item>
            <el-form-item label="结束剩余里程：" prop="end_mileage">
                <el-input v-model="model.end_mileage"></el-input>
            </el-form-item>
            <el-form-item label="起始电量：" prop="begin_soc">
                <el-input v-model="model.begin_soc"></el-input>
            </el-form-item>
            <el-form-item label="结束电量：" prop="end_soc">
                <el-input v-model="model.end_soc"></el-input>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed" v-if="model.report_type==2">
                <el-input v-model="model.avg_speed"></el-input>
            </el-form-item>
            <el-form-item label="平均功率：" prop="avg_power" v-if="model.report_type==2">
                <el-input v-model="model.avg_power"></el-input>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc" v-if="model.report_type==1">
                <el-input v-model="model.avg_enc"></el-input>
            </el-form-item>
            <el-form-item label="平均室内温度：" prop="avg_inside_temp">
                <el-input v-model="model.avg_inside_temp"></el-input>
            </el-form-item>
            <el-form-item label="平均室外温度：" prop="avg_outside_temp">
                <el-input v-model="model.avg_outside_temp"></el-input>
            </el-form-item>
            <el-form-item label="比较提示信息：" prop="compare_msg">
                <el-input v-model="model.compare_msg"></el-input>
            </el-form-item>
            <el-form-item label="动画时长：" prop="moving_duration" v-if="model.report_type==1">
                <el-input v-model="model.moving_duration" style="width: 150px"></el-input>（秒）
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getCarReportInfo } from '@/api/carreport'

export default {
    name: 'simulateLineEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                month: '',
                data_id: '',
                report_type: '',
                show_time: '',
                show_duration: '',
                charge_in: '',
                fee: '',
                mileage: '',
                begin_mileage: '',
                end_mileage: '',
                begin_soc: '',
                end_soc: '',
                avg_speed: '',
                avg_power: '',
                avg_enc: '',
                avg_inside_temp: '',
                avg_outside_temp: '',
                compare_msg: '',
                moving_duration: '',
                conn_charge_cable: '',
                begin_lng: '',
                begin_lat: '',
                end_lng: '',
                end_lat: '',
                begin_address: '',
                end_address: '',
            },
            getObj:{
                url:'/api/admin/simulateline/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['report_type'],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/simulateline/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        getReportInfo(){
            if(this.$isNull(this.model.month)){
                this.$msg("请选择月份")
                return
            }
            if(this.$isNull(this.model.data_id)){
                this.$msg("请输入数据ID")
                return
            }
            getCarReportInfo(this.model.data_id, this.model.month).then(res => {
                if (res.code === 1) {
                    let data = res.data
                    if(data.report_type != this.model.report_type){
                        this.$msg("报告类型错误")
                        return
                    }
                    this.model.show_time = data.show_time
                    this.model.show_duration = data.show_duration
                    this.model.charge_in = data.charge_in
                    this.model.fee = data.fee
                    this.model.mileage = data.mileage
                    this.model.begin_mileage = data.begin_mileage
                    this.model.end_mileage = data.end_mileage
                    this.model.begin_soc = data.begin_soc
                    this.model.end_soc = data.end_soc
                    this.model.avg_speed = data.avg_speed
                    this.model.avg_power = data.avg_power
                    this.model.avg_enc = data.avg_enc
                    this.model.avg_inside_temp = data.avg_inside_temp
                    this.model.avg_outside_temp = data.avg_outside_temp
                    this.model.compare_msg = data.compare_msg
                    this.model.conn_charge_cable = data.conn_charge_cable
                    this.model.begin_lng = data.begin_lng
                    this.model.begin_lat = data.begin_lat
                    this.model.end_lng = data.end_lng
                    this.model.end_lat = data.end_lat
                    this.model.begin_address = data.begin_address
                    this.model.end_address = data.end_address
                } else {
                    this.$msg(res.msg)
                }
            })
        },
        formateData() {
            this.model.report_type = this.model.report_type+''
        },
    }
};
</script>